<template>
    <script v-if="data" type="application/ld+json">{{ data }}</script>
</template>

<script>
    export default {
        props: {
            'data': Object
        }
    }
</script>
